import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import { StyleSheet, css } from 'aphrodite';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';

import { AppConfig } from '../AppConfig';
import { AppTheme } from '../styles/AppTheme';
import { Controller } from '../common/Controller';
import Icon from '@material-ui/core/Icon';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { data } from '../data/AdminData.js'
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import Input from '@material-ui/core/Input';
import { ApiHelperV2 } from '../common/helpers/ApiHelperV2';
import { UiHelper } from '../common/helpers/UiHelper';
import { Helper } from '../common/helpers/Helper';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';

export class Header extends Component {
  constructor(props) {
    super(props);
    this.eventData = data.eventData;
    this.appUser = Controller.get().userMgrV2().getUser()
    this.currentUserSettings = Controller.get().userMgrV2().getUserSettings()
    this.orgId = Controller.get().userMgrV2().getOrgId()
    this.state = {
      formErrorMsg: null,
      anchorEl: null,
      settingDialog: false,
      eventVisibility: this.currentUserSettings.EVENT_VISIBILITY,
      eventPriority: this.currentUserSettings.EVENT_EMAIL_ALERT,
      emailNotification: this.currentUserSettings.ALERT_EMAIL,
      emailNotificationValue: this.currentUserSettings.ALERT_EMAIL === 'ON' ? true : false,
      camSelected: [],
      orgSwitcher: false,
      currentOrgId: Controller.get().userMgrV2().getOrgId(),
      currentOrg: Controller.get().userMgrV2().getCurrentOrg(),
      fetchState: ApiHelperV2.State.LOADING
    }
    this.formContainer = {
      eventVisibility: {
        key: 'eventVisibility',
        title: 'EVENT VISIBILITY',
        label: 'Select Event Priority Level'
      },
      eventPriority: {
        key: 'eventPriority',
        title: 'EVENT PRIORITY LEVEL FOR EMAIL ALERTS',
        label: 'Select Event Priority Level'
      }
    }
    //console.log('Inside header logged in: ', this.props.currentUser);
  }

  componentDidMount() {
  }

  getCamIds() {
    if (!this.currentUserSettings.CAMERAS || this.currentUserSettings.CAMERAS.length === 0) {
      this.setState({
        fetchState: ApiHelperV2.State.READY
      })
      return [];
    } else {
      //const camIds = (this.currentUserSettings.CAMERAS).split(',');
      const camIds = this.currentUserSettings.CAMERAS;
      const selectedCamIds = []
      for (const item of this.state.items) {
        if (item._id === 'all') {
          for (const cam of item.cams) {
            if ((camIds).indexOf(cam._id) > -1) {
              selectedCamIds.push(cam._id)
            }
          }
        }
      }
      this.setState({
        camSelected: selectedCamIds,
        fetchState: ApiHelperV2.State.READY
      })
    }
  }

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  onsettingClick = () => {
    this.fetchCams();
    this.setState({ settingDialog: true });
  }

  dialogClose = () => {
    // const apiBody = this.dialogCloseValidation()
    this.setState({ settingDialog: false, anchorEl: null })
  }

  fieldsContainerChange = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  convertArrayToCsv(items) {
    let camIdStr = '';
    let index = 0;
    if (items && items.length > 0) {
      for (const item of items) {
        camIdStr = camIdStr + item;
        if (index !== (items.length - 1)) {
          camIdStr = camIdStr + ','
        }
        index = index + 1;
      }
      return camIdStr
    } else {
      return camIdStr
    }
  }

  saveSetting = () => {
    this.setState({
      formErrorMsg: null
    })
    let options = '';
    if (this.state.emailNotification === 'ON' && this.state.camSelected.length === 0) {
      this.setState({
        formErrorMsg: 'You have enabled email notifications. Please select atleast one camera.'
      })
      return
    }
    options = {
      method: 'POST',
      endPoint: ApiHelperV2.makeUrlPath(['users', this.appUser._id, 'settings'], { orgId: this.orgId }),
      jsonBody: {
        settings: {
          ALERT_EMAIL: this.state.emailNotification,
          EVENT_VISIBILITY: String(this.state.eventVisibility),
          EVENT_EMAIL_ALERT: String(this.state.eventPriority),
          CAMERAS: this.state.camSelected//this.convertArrayToCsv(this.state.camSelected)
        }
      }
    }
    ApiHelperV2.call(options, function (err, data) {
      if (err) {
        const msg = err.message ? err.message : 'An error occurred, please try again. Contact customer care if problem persists.';
        this.setState({
          errMsg: msg,
          errCode: err.respCode,
        })
        return
      }
      this.setState({
        settingDialog: false,
      })
      window.location.reload();
    }.bind(this))
  }

  formContainerFun = (formField) => {
    return (
      <div className={css(Styles.fieldsContainer)}>
        <p className={css(Styles.fieldsContainerHeader)}>{formField.title}</p>
        <FormControl className={css(Styles.formControl)}>
          <InputLabel classes={{
            root: css(Styles.inputLabelRoot),
            focused: css(Styles.inputLabelFocused)
          }}
          >{formField.label}</InputLabel>
          <Select
            value={this.state[formField.key]}
            onChange={this.fieldsContainerChange}
            classes={{
              root: css(Styles.root),
              select: css(Styles.select)
            }}
            inputProps={{
              name: formField.key,
            }}
            input={
              <Input
                classes={{
                  underline: css(Styles.textFieldContentInput)
                }}
              />
            }
          >
            {this.eventData.map(item => {
              return (
                <MenuItem className={css(Styles.menuItemSelect)} value={item.value}>{item.label}</MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </div>
    )
  }

  emailNotificationFun = name => event => {
    this.setState({ [name]: event.target.checked });
    if (event.target.checked) {
      this.setState({ emailNotification: 'ON' })
    } else {
      this.setState({ emailNotification: 'OFF' })
    }
  };

  fetchCams() {
    this.setState({
      fetchState: ApiHelperV2.State.LOADING
    })
    ApiHelperV2.call(
      { method: 'GET', endPoint: ApiHelperV2.makeUrlPath(['placesByOrgId'], { orgId: this.orgId }) },
      function (err, results) {
        if (err) {
          this.setState({
            fetchState: ApiHelperV2.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }
        if (results && results.length > 0) {
          let allCams = [];
          for (const r of results) {
            if (r.cams && r.cams.length > 0) {
              allCams = allCams.concat(r.cams)
            }
          }
          results.push({
            _id: 'all',
            name: 'All',
            cams: allCams
          })
        }

        this.setState({
          items: results,
        }, () => this.getCamIds())
      }.bind(this))
  }

  dialogFunction() {
    return (
      <Dialog
        onClose={this.dialogClose}
        open={this.state.settingDialog}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <div className={css(Styles.dialogTitle)}>
          <p className={css(Styles.dialogTitleContent)}>Settings</p>
          <div className={css(Styles.cancelIconContainer)}>
            <Icon className={css(Styles.cancelIcon)} onClick={() => this.dialogClose()} color='secondary'>cancel</Icon>
          </div>
        </div>
        {this.state.fetchState === ApiHelperV2.State.LOADING &&
          <div className={css(Styles.loadingView)}>
            {UiHelper.componentLoadingView()}
          </div>
        }
        {this.state.fetchState === ApiHelperV2.State.READY &&
          <div>
            <DialogContent className={css(Styles.dialogContent)}>
              {this.formContainerFun(this.formContainer.eventVisibility)}
              {this.formContainerFun(this.formContainer.eventPriority)}
              <div className={css(Styles.fieldsContainer)}>
                <p className={css(Styles.fieldsContainerHeader)}>EMAIL NOTIFICATIONS</p>
                <FormControlLabel
                  control={
                    <Switch
                      checked={this.state.emailNotificationValue}
                      onChange={this.emailNotificationFun('emailNotificationValue')}
                      value='emailNotificationValue'
                    />
                  }
                  classes={{
                    label: css(Styles.formControlLabel),
                  }}
                  label={this.state.emailNotification}
                />

                {this.state.emailNotificationValue &&
                  <FormControl className={css(Styles.formControl)}>
                    <InputLabel classes={{
                      root: css(Styles.inputLabelRoot),
                      focused: css(Styles.inputLabelFocused)
                    }}
                    >Select Cams</InputLabel>
                    <Select
                      disabled={!this.state.emailNotificationValue}
                      multiple
                      renderValue={selected => (
                        this.state.items &&
                        this.state.items.map(item => {
                          return (
                            item._id === 'all' &&
                            item.cams.map(cams => {
                              return (
                                selected.map(camSelect => {
                                  return (
                                    camSelect === cams._id &&
                                    [cams.name] + ', '
                                  )
                                }))
                            }))
                        })
                      )}
                      value={this.state.camSelected}
                      onChange={this.fieldsContainerChange}
                      classes={{
                        root: css(Styles.root),
                        select: css(Styles.select)
                      }}
                      inputProps={{
                        name: 'camSelected',
                      }}
                      input={
                        <Input
                          classes={{
                            underline: css(Styles.textFieldContentInput)
                          }}
                        />
                      }
                    >
                      {this.state.items &&
                        this.state.items.map(item => {
                          return (
                            item._id === 'all' &&
                            item.cams.map(list => {
                              return (
                                <MenuItem className={css(Styles.menuItemSelect)} value={list._id} key={list.name}>
                                  <Checkbox checked={this.state.camSelected.indexOf(list._id) > -1} />
                                  <ListItemText primary={list.name} />
                                </MenuItem>
                              )
                            })
                          )
                        })}
                    </Select>
                  </FormControl>
                }
              </div>

            </DialogContent>
            <DialogActions className={css(Styles.dialogActions)}>
              <Button
                variant='contained'
                onClick={() => this.saveSetting()}
                className={css(Styles.actionButton)}>
                Save
              </Button>
              <p className={css(Styles.formErrorMsg)}>{this.state.formErrorMsg}</p>
            </DialogActions>
          </div>
        }
      </Dialog >
    );
  }

  closeOrgSwitcher = () => {
    this.setState({
      orgSwitcher: false,
      anchorEl: null,
    })
  }

  showOrgSwitcher = () => {
    this.setState({
      orgSwitcher: true
    })
  }

  submitOrg = () => {
    Controller.get().userMgrV2().updateCurrentOrg(this.state.currentOrg)
    const home = Controller.get().userMgrV2().getUserHome()
    Controller.get().pushRoute(home);
    window.location.reload()
  }

  onSelect = event => {
    for (const item of this.props.currentUser.orgs) {
      if (item._id === event.target.value) {
        this.setState({
          [event.target.name]: event.target.value,
          currentOrg: item,
        });
        break;
      }
    }
  };

  renderOrgSwitcher() {
    return (
      <Dialog
        onClose={this.closeOrgSwitcher}
        open={this.state.orgSwitcher}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <div className={css(Styles.dialogTitle)}>
          <p className={css(Styles.dialogTitleContent)}>Select an Organisation</p>
          <div className={css(Styles.cancelIconContainer)}>
            <Icon className={css(Styles.cancelIcon)} onClick={() => this.closeOrgSwitcher()} color='secondary'>cancel</Icon>
          </div>
        </div>
        <div>
          <DialogContent className={css(Styles.dialogContent)}>
            <div className={css(Styles.fieldsContainer)}>
              <FormControl className={css(Styles.selectInnerContainer)}>
                <InputLabel>{'Organization'}</InputLabel>
                <Select
                  name={'currentOrgId'}
                  value={this.state.currentOrgId}
                  onChange={this.onSelect}
                >
                  {this.props.currentUser.orgs.map(item => {
                    return (
                      <MenuItem value={item._id}>{item.name}</MenuItem>
                    )
                  })}
                </Select>
              </FormControl>
            </div>
          </DialogContent>
          <DialogActions className={css(Styles.dialogActions)}>
            <Button
              variant='contained'
              onClick={() => this.submitOrg()}
              className={css(Styles.actionButton)}>
              Save
            </Button>
            <p className={css(Styles.formErrorMsg)}>{this.state.formErrorMsg}</p>
          </DialogActions>
        </div>
      </Dialog >
    );
  }

  isFullScreenMode() {
    if (this.fullScreenMode &&
      window.location &&
      window.location.pathname &&
      (window.location.pathname).indexOf('places') >= 0 &&
      (window.location.pathname).indexOf('cams') >= 0) {
      return true
    }
    return false
  }

  render() {
    this.fullScreenMode = Controller.get().userMgrV2().getFullScreenMode()

    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);
    const logo = Controller.get().userMgrV2().getProductLogo();
    if (this.isFullScreenMode()) {
      return <div></div>
    }

    return (
      <div>
        <AppBar className={css(Styles.appbar)} color='primary' position='fixed' elevation={0}>
          <Toolbar className={css(Styles.toolbar)}>
            <div className={css(Styles.logoContainer)}>
              <Link to={'/'}>
                <div className={css(Styles.logoImageContainer)}>
                  <img src={logo ? logo : require('../assets/images/logo.png')} alt='Logo' className={css(Styles.logoImage)} />
                </div>
              </Link>
              {/*<div className={css(Styles.logoContainerIcon)}>
                <Icon className={css(Styles.logoIcons)} color='secondary'>
              person
                </Icon>
              </div>*/}
            </div>

            <div className={css(Styles.headerContentContainer)}>
              <p className={css(Styles.headerContent)}>{AppConfig.navbarTitle}</p>
            </div>

            {this.props.currentUser &&
              <div>
                <IconButton
                  aria-owns={open ? 'menu-appbar' : null}
                  aria-haspopup='true'
                  onClick={this.handleMenu}
                  color='secondary'
                  className={css(Styles.iconsAccount)}
                >
                  <i className='material-icons'>account_circle</i>
                </IconButton>
                <Menu
                  id='menu-appbar'
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={open}
                  onClose={this.handleClose}
                >

                  {this.props.currentUser && this.props.currentUser.phone &&
                    <MenuItem disabled>Phone:{this.props.currentUser.phone}</MenuItem>
                  }
                  {this.state.currentOrg &&
                    <MenuItem
                      className={css(Styles.menuItem)}
                      onClick={() => this.showOrgSwitcher()} >
                      <Icon className={css(Styles.icons)} color='secondary'>home</Icon>{this.state.currentOrg.name}
                    </MenuItem>
                  }
                  {!Controller.get().userMgrV2().isProductUser() &&
                    <MenuItem onClick={() => this.onsettingClick()} className={css(Styles.menuItem)}>
                      <Icon className={css(Styles.icons)} color='secondary'>settings</Icon>SETTINGS
                    </MenuItem>
                  }
                  <MenuItem onClick={this.props.onLogoutClick} className={css(Styles.menuItem)}>
                    <Icon className={css(Styles.icons)} color='secondary'>power_settings_new</Icon>LOGOUT
                  </MenuItem>
                  <p className={css(Styles.versionNumber)}>Version {AppConfig.Version}</p>
                </Menu>
              </div>
            }
          </Toolbar>
        </AppBar>
        {this.dialogFunction()}
        {this.state.orgSwitcher &&
          this.renderOrgSwitcher()
        }
      </div>
    );
  }

}



const Styles = StyleSheet.create({
  appbar: {
    backgroundColor: '#303E8A',
    height: 65,
    position: 'relative'
  },
  toolbar: {
    paddingLeft: 10,
    paddingRight: 10,
  },
  logoImageContainer: {
    width: 'auto',//300,
    height: 65
  },
  headerContentContainer: {
    padding: '0px 20px',
    textAlign: 'center',
    flex: 1,
    overflow: 'hidden',
  },
  headerContent: {
    margin: 0,
    fontSize: 24,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 'bold'
  },
  logoImage: {
    maxWidth: '100%',
    maxHeight: '100%'
  },
  logoContainer: {
    display: 'flex',
    // flex: 1,
    // textAlign: 'left'
  },
  logoContainerIcon: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    flex: 1
  },
  logoIcons: {
    backgroundColor: 'white',
    color: '#303E8A',
    borderRadius: '50%',
    marginRight: 10
  },
  headerInfo: {
    fontSize: 14,
    color: 'black',
    textAlign: 'right'
  },
  headerTelephone: {
    fontSize: 14,
    textDecoration: 'none',
    color: 'black'
  },
  iconsAccount: {
    color: 'white'
  },
  icons: {
    color: '#757575',
    marginRight: 8
  },
  menuItem: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600,
    fontSize: 15
  },
  dialog: {
    minWidth: 500,
    '@media(max-width: 767px)': {
      minWidth: '-webkit-fill-available',
      margin: 5
    }
  },
  scrollPaper: {
    justifyContent: 'center',
    '@media(max-width: 767px)': {
      overflow: 'scroll',
      justifyContent: 'flex-start'
    }
  },
  dialogTitle: {
    padding: 15,
    display: 'flex'
  },
  dialogTitleContent: {
    fontWeight: 600,
    fontSize: 23,
    margin: 0,
    color: 'black'
  },
  dialogContent: {
    padding: '0px 15px',
  },
  fieldsContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: AppTheme.secondaryBg,
    padding: '20px 10px',
    marginBottom: 10
  },
  fieldsContainerHeader: {
    margin: 0,
    marginBottom: 10,
    fontWeight: 'bold',
    fontSize: 15
  },
  formControlLabel: {
    fontWeight: 'bolder',
    fontSize: 17
  },
  formControl: {
    width: 240
  },
  dialogActions: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    margin: '0px 15px 15px',
    display: 'flex',
    justifyContent: 'flex-start'
  },
  actionButton: {
    backgroundColor: '#3F51B5',
    color: 'white',
    fontWeight: 'bolder',
    margin: 0,
    fontSize: 16,
    textTransform: 'unset'
  },
  select: {
    color: 'black',
    fontWeight: 600
  },
  inputLabelRoot: {
    color: '#757575'
  },
  inputLabelFocused: {
    color: '#3F51B5'
  },
  root: {
    color: 'black'
  },
  textFieldContentInput: {
    color: 'black',
    fontWeight: 600,
    ':before': {
      borderBottom: '2px solid #757575',
    },
    ':after': {
      borderBottom: '2px solid #3F51B5',
    },
  },
  menuItemSelect: {
    fontWeight: 600
  },
  cancelIconContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  cancelIcon: {
    color: 'black',
    cursor: 'pointer'
  },
  versionNumber: {
    margin: 0,
    fontSize: 10,
    textAlign: 'center',
    paddingTop: 5,
    outline: 'none',
    cursor: 'default'
  },
  formErrorMsg: {
    margin: 0,
    marginTop: 10,
    color: 'red',
  },
  loadingView: {
    maxHeight: 500,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  selectInnerContainer: {
    flex: .5,
    display: 'flex',
    marginBottom: 10,
    color: 'black',
    fontSize: 18
  },
})


// WEBPACK FOOTER //
// ./src/components/Header.js